import script from "./customFieldComponentStructure.vue?vue&type=script&setup=true&lang=js"
export * from "./customFieldComponentStructure.vue?vue&type=script&setup=true&lang=js"

import "./customFieldComponentStructure.vue?vue&type=style&index=0&id=1c0f6542&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c0f6542"]])

export default __exports__